// extracted by mini-css-extract-plugin
export var footer = "_mf-5";
export var fulfillmentInput = "_mf-0";
export var shipDateInput = "_mf-1";
export var shipmentModal = "_mf-2";
export var shipmentModalContent = "_mf-3";
export var tableContainer = "_mf-4";